import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import clipperImage from "../../assets/images/ClipperCut.jpg";
import RainbowButton from "../shared/RainbowButton";
import "./IntroContent.css";

export default function IntroContent() {
  return (
    <Container className="intro-section">
      <Row className="align-items-center g-5">
        <Col xs={12} lg={7}>
          <div className="intro-content-card">
            <div className="intro-header">
              <h2 className="intro-title">About Us</h2>
              <div className="intro-accent-line"></div>
            </div>

            <div className="intro-text">
              <p className="intro-description">
                We are a locally owned and operated business dedicated to
                serving your entire family with exceptional hair care services.
              </p>
              <p className="intro-mission">
                Our mission is to deliver quality hair care while creating
                an atmosphere built on <span className="highlight-text">respect</span>,
                <span className="highlight-text"> creativity</span>,
                <span className="highlight-text"> community</span>,
                <span className="highlight-text"> love</span>, and
                <span className="highlight-text"> fun</span>.
              </p>
              <div className="intro-hours">
                <div className="hours-label">Open Seven Days a Week</div>
                <div className="contact-info">
                  For detailed hours: <span className="phone-number">(719) 452-1343</span>
                </div>
              </div>
            </div>

            <div className="intro-cta">
              <RainbowButton
                text="Meet Our Team"
                href="/meet-the-team"
                newTab={false}
              />
            </div>
          </div>
        </Col>

        <Col xs={12} lg={5}>
          <div className="intro-image-container">
            <div className="image-backdrop"></div>
            <Image
              src={clipperImage}
              alt="Professional Hair Styling"
              className="intro-image"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
